import React from 'react';
import { Mail, Phone, Clock } from "lucide-react";
import ReactGA from 'react-ga4';

const ContactDetails = () => {
    const handleCopy = (text: string, label: string) => {
        navigator.clipboard.writeText(text).then(() => {

            // Send GA event
            ReactGA.event({
                category: 'Contact',
                action: 'Copy',
                label: label
            });
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 text-gray-800 text-base">
            {/* Email */}
            <div className="flex items-center space-x-3">
                <Mail className="w-6 h-6 text-pink-500" />
                <div>
                    <p className="font-semibold">Email</p>
                    <div className="flex space-x-2">
                        <a href="mailto:theonechildcare@gmail.com" className="text-blue-600 hover:underline">
                            theonechildcare@gmail.com
                        </a>
                        <button
                            onClick={() => handleCopy('theonechildcare@gmail.com', 'Email')}
                            className="text-sm text-gray-500 hover:text-gray-700"
                        >
                            Copy
                        </button>
                    </div>
                </div>
            </div>

            {/* Phone */}
            <div className="flex items-center space-x-3">
                <Phone className="w-6 h-6 text-pink-500" />
                <div>
                    <p className="font-semibold">Phone</p>
                    <div className="flex space-x-2">
                        <a href="tel:07398909388" className="text-blue-600 hover:underline">
                            07398 909388
                        </a>
                        <button
                            onClick={() => handleCopy('07398909388', 'Phone')}
                            className="text-sm text-gray-500 hover:text-gray-700"
                        >
                            Copy
                        </button>
                    </div>
                </div>
            </div>

            {/* Opening Hours */}
            <div className="flex items-center space-x-3">
                <Clock className="w-6 h-6 text-pink-500" />
                <div>
                    <p className="font-semibold">Opening Hours</p>
                    <p>Mon–Fri: 8:00 AM – 6:00 PM</p>
                </div>
            </div>
        </div>
    );
};

export default ContactDetails;
